import { Component, ViewChild, OnInit } from '@angular/core';

import { RulesEditorComponent } from '../../../common/components/rules-editor/rules-editor.component';

import { Dialog, DialogButton } from "../../../core/models/dialog.model";
import { DynamicDialogService } from "../../../core/services/dynamic-dialog.service";
import { genId } from "../../../core/services/genId";
import { SidePanelBase } from "../../../common/components/side-panel-base.class";
import { ValidationRuleGenerator } from '../../services/validation-generator.service';

import { deepClone } from '../../models/editor.model';
import { Question, QuestionKind, Rule, ValidationRule } from '../../../common/models/flow.dto';
import { ValidatorPatterns } from '../../../common/classes/validator-patterns';

@Component({
    selector: 'state-builder-validation',
    templateUrl: './state-builder-validation.component.html',
    standalone: false
})
export class StateBuilderValidationComponent extends SidePanelBase implements OnInit {

  static componentName: string = 'StateBuilderValidationComponent';

  public _validationGenerator: ValidationRuleGenerator = new ValidationRuleGenerator();
  public selectedRuleId: string;

  @ViewChild(RulesEditorComponent) public ruleEditor: RulesEditorComponent;

  set currentQuestion(value: Question) {
    this.componentData.currentQuestion = value;
    if (!this.componentData.currentQuestion.validationRules)
      this.componentData.currentQuestion.validationRules = [];

    this.setValidationsForQuestionType();
  }

  get currentQuestion(): Question {
    if (!this.componentData) {
      return {
        key: '',
        label: '',
        helpText: '',
        config: '',
        type: QuestionKind.Checkbox,
        contextTarget: '',
        enabledRule: null,
        validationRules: [],
        visibleRule: null,
        changeRules: [],
        flexGrow: -1,
        //"files": [],
        notes: [],
        defaultValue: undefined
      }
    }
    if (this.componentData.currentQuestion === null || this.componentData.currentQuestion === undefined) {
      this.componentData.currentQuestion = {
        key: '',
        label: '',
        helpText: '',
        config: '',
        type: QuestionKind.Checkbox,
        contextTarget: '',
        enabledRule: null,
        validationRules: [],
        visibleRule: null,
        changeRules: [],
        flexGrow: -1,
        //"files": [],
        notes: [],
        defaultValue: undefined
      };
    } else if (!this.componentData.currentQuestion.validationRules) {
      this.componentData.currentQuestion.validationRules = [];
    }
    return this.componentData.currentQuestion;
  }

  public currentValidation: ValidationRule;
  public currentValidationClone: ValidationRule;
  public customValue: any;
  public customValueText: string;
  public fieldValidationOptions: any[] = [];
  public isEditingExistingValidation: boolean = false;
  public validEmail: any = {
    id: '3',
    text: 'Email - ex. example@example.com',
    value: ValidatorPatterns.Email,
    generator: (context, pattern) => this._validationGenerator.generateRegexRule(context, pattern)
  };
  public validBoolRequired: any = {
    id: 'requiredbool',
    text: 'Required',
    value: ValidatorPatterns.RequiredBool,
    generator: (context, pattern) => this._validationGenerator.generateRegexRule(context, pattern)
  };
  public validCustom: any = { id: 'custom', text: 'Custom' };
  public validCustomRegEx: any = { id: 'custom-regex', text: 'Custom Regular Expression', value: undefined, generator: (context, pattern) => this._validationGenerator.generateRegexRule(context, pattern) };
  public validEmpty: any = { id: undefined, text: '--Select Validation Type--', value: undefined, generator: undefined };
  public validInternationalPhone: any = {
    id: '2',
    text: 'International Phone - +001 (555) 555-5555',
    value: ValidatorPatterns.InternationalPhone,
    generator: (context, pattern) => this._validationGenerator.generateRegexRule(context, pattern)
  };
  public validMaxLength: any = { id: 'max-length', text: 'Maximum Length', value: 10, generator: (context, value) => this._validationGenerator.generateMaximumRule(context, value) };
  public validMinLength: any = { id: 'min-length', text: 'Minimum Length', value: 0, generator: (context, value) => this._validationGenerator.generateMinimumRule(context, value) };
  public validPhone: any = {
    id: '1',
    text: 'Phone - (555) 555-5555',
    value: ValidatorPatterns.Phone,
    generator: (context, pattern) => this._validationGenerator.generateRegexRule(context, pattern)
  };
  public validRequiredLineBreak: any = { id: 'required', text: 'Required', generator: (context, pattern) => this._validationGenerator.generateRequiredRuleLineBreak(context) };
  public validRequired: any = { id: 'required', text: 'Required', generator: (context, pattern) => this._validationGenerator.generateRequiredRule(context) };
  public validUrl: any = {
    id: '4',
    text: 'Website URL - www.example.com',
    value: ValidatorPatterns.Url,
    generator: (context, pattern) => this._validationGenerator.generateRegexRule(context, pattern)
  };
  public validSignature: any = { id: "signature", text: "Signature", generator: (context, confirmation) => this._validationGenerator.generateSignatureRule(context, confirmation) };
  public validRequiredObj: any = {
    id: 'required-obj',
    text: 'Required',
    generator: (context) => this._validationGenerator.generateRequiredObject(context)
  };
  public validRequiredFile: any = {
    id: 'required-file',
    text: 'Required',
    generator: (context) => this._validationGenerator.generateRequiredFile(context)
  };
  public validRequiredChoiceFile: any = {
    id: 'required-choice-file',
    text: 'Required (use with radio options)',
    generator: (context) => this._validationGenerator.generateRequiredChoiceFile(context)
    };

    public validLatitude: any = {
        id: "latitude-validation",
        text: "Latitude",
        generator: (context) => this._validationGenerator.generateLatitudeRule(context)
    };

    public validLongitude: any = {
        id: "longitude-validation",
        text: "Longitude",
        generator: (context) => this._validationGenerator.generateLongitudeRule(context)
    }

    dialog: Dialog = new Dialog("Are you sure you want to delete this validation?", [new DialogButton("Yes", true, () => this.onDialogConfirm()), new DialogButton("No", false, () => this.onDialogClose())]);


    constructor(public dialogService: DynamicDialogService) {
        super();

        //populate empty rule for edits
        this.currentValidation = this.getNewValidationRule();
      }

  public ngOnInit(): void {
      this.setValidationsForQuestionType();
      this.dialogService.updateDialog(this.dialog);
  }

  public addValidation(): void {
    //add to array
    this.generateCannedRule();
    this.currentQuestion.validationRules.push(this.currentValidation);
    this.updateConfigValidation();
    //reset editor interface
    this.clearEditor();
  }

  public cancelValidation(): void {
    if (this.isEditingExistingValidation) {
      //reset to pre-edited state
      this.currentValidation = this.currentValidationClone;
      //update validation array value
      this.updateValidation();
    }
    //reset editor interface
    this.clearEditor();
  }

  public clearEditor(): void {
    //set new empty validationRule
    this.currentValidation = this.getNewValidationRule();
    //set available buttons
    this.isEditingExistingValidation = false;
    this.customValue = undefined;
  }

  public deleteValidation(ruleId: string): void {
    this.selectedRuleId = ruleId;
      this.dialog.toggleDialog(true);
      this.dialogService.updateDialog(this.dialog);
  }

  public editValidation(validation: ValidationRule): void {
    //clone to separate form ref
    if (validation.onSubmitOnly === undefined) {
      validation.onSubmitOnly = false;
    }
    this.currentValidationClone = deepClone(validation);
    this.currentValidation = validation;

    let customRegex = this.currentQuestion.config.validations.find(x => x.id === this.currentValidation.ruleId);

    if (customRegex)
      this.customValue = customRegex.regex;

    //set available buttons
      this.isEditingExistingValidation = true;
      switch (this.currentValidation.key) {
          case 'custom-regex':
              this.customValueText = 'Regular Expression Pattern';
              break;
          case 'min-length':
              this.customValueText = 'Minimum Length';
              break;
          case 'max-length':
              this.customValueText = 'Maximum Length';
              break;
          default:
              this.customValueText = undefined;
      }
  }

public generateCannedRule(): void {
    if (this.currentValidation.key) {
        switch (this.currentValidation.key) {
            case "signature": {
                const selectedValue = this.fieldValidationOptions.find(x => x.id === this.currentValidation.key);
                let rule = selectedValue.generator(`${this.currentQuestion.contextTarget}`, "agree");
                rule.key = this.currentValidation.key;
                rule.name = this.currentValidation.name || rule.name;
                this.currentValidation = rule;
                this.customValue = selectedValue.value || this.customValue;
                break;
                }
            case "required-file":
            case "required-choice-file": {
                const selectedValue = this.fieldValidationOptions.find(x => x.id === this.currentValidation.key);
                let rule = selectedValue.generator(`${this.currentQuestion.contextTarget}`);
                rule.key = this.currentValidation.key;
                rule.name = this.currentValidation.name || rule.name;
                this.currentValidation = rule;
                this.customValue = selectedValue.value || this.customValue;
                break;
                }
            case "required-obj": {
                const selectedValue = this.fieldValidationOptions.find(x => x.id === this.currentValidation.key);
                let rule = selectedValue.generator(`${this.currentQuestion.contextTarget}.value`);
                rule.key = this.currentValidation.key;
                rule.name = this.currentValidation.name || rule.name;
                this.currentValidation = rule;
                this.customValue = selectedValue.value || this.customValue;
                break;
                }
            case "custom":
                break;
            default: {
                let selectedValue = this.fieldValidationOptions.find(x => x.id === this.currentValidation.key);
                let rule = selectedValue.generator(`${this.currentQuestion.contextTarget}.value`, this.customValue || selectedValue.value);
                rule.key = this.currentValidation.key;
                rule.name = this.currentValidation.name || rule.name;
                this.currentValidation = rule;
                this.customValue = selectedValue.value || this.customValue;
                break;
            }
        }
    }
    switch (this.currentValidation.key) {
        case 'custom-regex':
        this.customValueText = 'Regular Expression Pattern';
        break;
        case 'min-length':
        this.customValueText = 'Minimum Length';
        break;
        case 'max-length':
        this.customValueText = 'Maximum Length';
        break;
        default:
        this.customValueText = undefined;
    }
}

  public getNewValidationRule(): ValidationRule {
    return <ValidationRule>{
      ruleId: genId(),
      name: '',
      expression: '',
      key: undefined,
      message: '',
      onSubmitOnly: false
    }
  }

  public hideNoValidation(): boolean {
    if (this.currentQuestion === undefined || this.currentQuestion.validationRules === undefined) {
      return false
    } else {
      return this.currentQuestion.validationRules.length > 0;
    }
  }

  public isInvalidValidation(): boolean {
    let isValid = !!this.currentValidation.name
      && !!this.currentValidation.message
      && !!this.currentValidation.key
      && this.currentQuestion.validationRules.filter(x => x.name === this.currentValidation.name).length <= (this.isEditingExistingValidation ? 1 : 0);

    if (this.currentValidation.key === 'custom' && this.ruleEditor)
      return !(isValid && this.ruleEditor.compileSuccessful);
    else if (this.currentValidation.key === 'custom-regex')
      return !(isValid && !!this.customValue);
    else
      return !(isValid);
  }

  public log(): void {
    console.log(this.currentQuestion);
  }

  public setValidationsForQuestionType(): void {
    this.fieldValidationOptions = [];

    if (!this.currentQuestion) return;

    this.fieldValidationOptions.push(this.validEmpty);

    switch (this.currentQuestion.type) {
      case QuestionKind.YesNoToggle:
      case QuestionKind.Checkbox:
        {
          this.fieldValidationOptions.push(this.validBoolRequired);
          break;
        }
      case QuestionKind.DatePicker:
      case QuestionKind.Radio:
      case QuestionKind.Dropdown:
        {
          this.fieldValidationOptions.push(this.validRequired);
          break;
        }
        case QuestionKind.ListEntry:
        case QuestionKind.Combo: {
            this.fieldValidationOptions.push(this.validMaxLength);
            this.fieldValidationOptions.push(this.validMinLength);
            this.fieldValidationOptions.push(this.validRequired);
            break;
        }
      case QuestionKind.FileUpload:
        {
          this.fieldValidationOptions.push(this.validMaxLength);
          this.fieldValidationOptions.push(this.validMinLength);
          this.fieldValidationOptions.push(this.validRequiredFile);
          this.fieldValidationOptions.push(this.validRequiredChoiceFile);
          break;
        }
      case QuestionKind.MultiselectCheckbox:
        this.fieldValidationOptions.push(this.validRequired);
        break;
      case QuestionKind.Textbox:
      case QuestionKind.TextArea:
        {
          this.fieldValidationOptions.push(this.validCustom);
          this.fieldValidationOptions.push(this.validCustomRegEx);
          this.fieldValidationOptions.push(this.validEmail);
          this.fieldValidationOptions.push(this.validInternationalPhone);
          this.fieldValidationOptions.push(this.validMaxLength);
          this.fieldValidationOptions.push(this.validMinLength);
          this.fieldValidationOptions.push(this.validPhone);
          this.fieldValidationOptions.push(this.validRequiredLineBreak);
          this.fieldValidationOptions.push(this.validUrl);
          this.fieldValidationOptions.push(this.validLatitude);
          this.fieldValidationOptions.push(this.validLongitude);
          break;
        }
      case QuestionKind.ESignature:
        {
          this.fieldValidationOptions.push(this.validCustom);
          this.fieldValidationOptions.push(this.validCustomRegEx);
          this.fieldValidationOptions.push(this.validSignature);
          break;
        }
      case QuestionKind.PhoneInput:
      {
        this.fieldValidationOptions.push(this.validCustomRegEx);
        this.fieldValidationOptions.push(this.validRequired);
        this.fieldValidationOptions.push(this.validInternationalPhone);
        this.fieldValidationOptions.push(this.validPhone);
      }
    }
  }

  public updateConfigValidation(): void {
    if (!this.currentQuestion.config.validations)
      this.currentQuestion.config.validations = [];

    let exists = this.currentQuestion.config.validations.findIndex(x => x.id === this.currentValidation.ruleId);

    if (exists > -1)
      this.currentQuestion.config.validations[exists].regex = this.customValue;
    else
      this.currentQuestion.config.validations.push({ id: this.currentValidation.ruleId, regex: this.customValue });
  }

  public updateValidation(): void {
    for (let i = 0; i < this.currentQuestion.validationRules.length; i++) {
      if (this.currentQuestion.validationRules[i].ruleId === this.currentValidation.ruleId) {
        this.currentQuestion.validationRules[i] = this.currentValidation;
        this.updateConfigValidation();
        break;
      }
    }
    //reset editor interface
    this.clearEditor();
  }

  public onDialogConfirm(): void {
    for (let i = 0; i < this.currentQuestion.validationRules.length; i++) {
      let vRule = this.currentQuestion.validationRules[i];
      if (vRule.ruleId === this.selectedRuleId) {
        this.currentQuestion.validationRules.splice(i, 1);

        if (this.currentQuestion.config.validations) {
          let index = this.currentQuestion.config.validations.findIndex(x => x.id === vRule.ruleId);

          this.currentQuestion.config.validations.splice(index, 1);
        }

        break;
      }
    }
    this.clearEditor();
  }

  public onDialogClose(): void {
  }

}
